import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const RequireAdmin: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { loading, isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) return <div className="min-h-screen grid place-items-center text-gray-600">Checking access…</div>;
  if (!isAuthenticated) return <Navigate to="/admin" replace state={{ from: location.pathname }} />;
  if (!isAdmin) {
    return <div className="min-h-screen grid place-items-center p-6 text-center">
      <div><h1 className="text-2xl font-bold">Access denied</h1><p className="mt-2 text-gray-600">Your account has no NWLC staff role.</p></div>
    </div>;
  }
  return children;
};

export default RequireAdmin;
